import clsx from 'clsx';

import { REQUIRED_TENANT_SPECIFIC_CTA_COLOR } from 'data/mypage';

function RichTextEditorCTALink({ attributes, element, children, style }: any) {
  return (
    <a
      {...attributes}
      href={element.href}
      style={style}
      className={clsx(
        'inline-block px-4 py-2 mb-1 font-bold border rounded',
        REQUIRED_TENANT_SPECIFIC_CTA_COLOR,
      )}
    >
      {children}
    </a>
  );
}

export default RichTextEditorCTALink;
